// extracted by mini-css-extract-plugin
module.exports = {"container":"_1DRX-","list":"vgbz1","event":"_2_p4_","title":"_3pAmS","chevron":"_3YuxE","info":"_2cCr8","time":"_3_TOg"};